import axios from 'axios';

export function getTranslations({ language, namespace }) {
  return axios
    .get('/api/admin/translations', {
      params: { language, namespace },
    })
    .then(res => res.data);
}

export function getLanguages() {
  return axios.get('/api/admin/translations/languages').then(res => res.data);
}

export function getSourceTexts({ namespace = 'translation' } = {}) {
  return axios
    .get('/api/admin/translations/source-texts', {
      params: { namespace },
    })
    .then(res => res.data);
}

export function getAllSourceTexts() {
  return axios
    .get('/api/admin/translations/all-source-texts')
    .then(res => res.data);
}

export function getLanguageTranslations({ language, namespace } = {}) {
  return axios
    .get(`/api/admin/translations/show/${language}`, {
      params: namespace ? { namespace } : {},
    })
    .then(res => res.data);
}

export function createTranslation(payload) {
  return axios.post('/api/admin/translations', payload).then(res => res.data);
}

export function updateTranslation(id, { value }) {
  return axios
    .put(`/api/admin/translations/${id}`, { value })
    .then(res => res.data);
}

export function deleteTranslation(id) {
  return axios.delete(`/api/admin/translations/${id}`).then(res => res.data);
}
